module.exports = __webpack_public_path__ + "img/bg.b0242da5.png";